import styled from "styled-components"
import { Link } from "react-router-dom"

export default function ChallengeProcessbtn() {
  return <Button to="/task/list">제품 인증하러 가기</Button>
}

const Button = styled(Link)`
  font-size: calc(100vw * (14 / 375));
  font-weight: 600;
  line-height: calc(100vw * (16 / 375));
  background-color: #ffcf19;
  border-radius: calc(100vw * (5 / 375));
  text-align: center;
  padding: calc(100vw * (14 / 375)) 0;
  margin-top: calc(100vw * (10 / 375));
`
